import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=6c872fb6&scoped=true&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=6c872fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c872fb6",
  null
  
)

export default component.exports